import { React, useEffect, useState } from "react";
import {
  Navigate,
  Route,
  HashRouter as Router,
  Routes,
} from "react-router-dom";
import Dashboard from "../components/Dashboard";
import One from "../components/Home";
import Login from "../components/Login";
import Paymentdetials from "../customerportal/Paymentdetials";
import Customerlist from "../salesportal/Customerlist";
import Tasks from "../salesportal/Tasks";
import FactoryProduction from "../salesportal/FactoryProduction";
import PurchasePage from "../salesportal/Purchase";
import Teammembers from "../salesportal/Teammembers";
import Employee from "../users/Emplyoee";
import Customfooter from "../Customcomponents/Customfooter.jsx";
import CashBook from "../accounts/CashBook.jsx";
import Incomeandexpenses from "../accounts/Incomeandexpenses.jsx";
import Labourpaymentreport from "../accounts/Labourpaymentreport.jsx";
import Pettycash from "../accounts/Pettycash.jsx";
import Civilactualprocurement from "../civilheadportal/Civilactualprocurement";
import Civilintialprocurelist from "../civilheadportal/Civilintialprocurelist";
import Civilintialprourement from "../civilheadportal/Civilintialprourement";
import Civilqueries from "../civilheadportal/Civilqueries";
import PettyCashExpense from "../civilheadportal/PettyCashExpense.jsx";
import SubcontractorEstimate from "../civilheadportal/SubcontractorEstimate.jsx";
import Subcontractorslist from "../civilheadportal/Subcontractorslist.jsx";
import Subcontractortype from "../civilheadportal/Subcontractortype.jsx";
import Forgotpassword from "../components/Forgotpassword.jsx";
import Pagenotfound from "../components/Pagenotfound.jsx";
import Setpassword from "../components/Setpassword.jsx";
import TokenExpired from "../components/invalidtoken.jsx";
import Actualprocurement from "../customerportal/Actualprocurement";
import CustomerDashboard from "../customerportal/CustomerDashboard.jsx";
import NewRequest from "../customerportal/NewRequest.jsx";
import ProjectTracking from "../customerportal/ProjectTracking.jsx";
import Purchaseintialprocurement from "../purchaseheadportal/Purchaseintialprocurement.jsx";
import Purchaselistitem from "../purchaseheadportal/Purchaselistitem.jsx";
import VendorEstimates from "../purchaseheadportal/VendorEstimates.jsx";
import Vendorlist from "../purchaseheadportal/Vendorlist.jsx";
import Vendortypes from "../purchaseheadportal/Vendortypes.jsx";
import Salesaddprojects from "../salesportal/Salesaddprojects.jsx";
import Salespreexecutionchecklist from "../salesportal/Salespreexecutioncheclist.jsx";
import Salesprojects from "../salesportal/Salesprojects.jsx";
import PendingAllocations from "../salesportal/PendingAllocations.jsx";
import PaymentsDashboard from "../salesportal/PaymentsDashboard.jsx";
import Reports from "../salesportal/Reports.jsx";
import SiteMarkingReport from "../salesportal/reports/SiteMarkingReport.jsx";
import ThreeDDiscussionReport from "../salesportal/reports/ThreeDDiscussionReport.jsx";
import QuotationReport from "../salesportal/reports/QuotationReport.jsx";
import TwoDMaterialReport from "../salesportal/reports/TwoDMaterialReport.jsx";
import HandoverPendingReport from "../salesportal/reports/HandoverPendingReport.jsx";
import CutlistPendingReport from "../salesportal/reports/CutlistPendingReport.jsx";
import CutlistDoneReport from "../salesportal/reports/CutlistDoneReport.jsx";
import FactoryProdReport from "../salesportal/reports/FactoryProdReport.jsx";
import DispatchPendingReport from "../salesportal/reports/DispatchPendingReport.jsx";
import CarcassReport from "../salesportal/reports/CarcassReport.jsx";
import SiteMaskingPendingReport from "../salesportal/reports/SiteMaskingPendingReport.jsx";
import PlanVsActualReport from "../salesportal/reports/PlanVsActualReport.jsx";
import AccessoriesReport from "../salesportal/reports/AccessoriesReport.jsx";
import FinalFittingReport from "../salesportal/reports/FinalFittingReport.jsx";
import ProjectBreakdownReport from "../salesportal/reports/ProjectBreakdownReport.jsx";
import TimelineReport from "../salesportal/reports/TimelineReport.jsx";
import Salessignoffdoc from "../salesportal/Salessignoffdoc.jsx";
import Salessignoffdocview from "../salesportal/Salessignoffdocview.jsx";
import useStorage from "./storageHook.jsx";

const Routers = () => {
  const currentUserRole = localStorage.getItem("role");
  const hasTokenValue = useStorage("token");
  const [hasToken, setHasToken] = useState(true);
  const routesList = [
    {
      path: "/",
      element: <Login />,
      children: [],
      requireToken: false,
    },
    {
      path: "/login",
      element: <Login handleChangeToken={handleChangeToken} />,
      children: [],
      requireToken: false,
    },
    {
      path: "/forgotpassword",
      element: <Forgotpassword />,
      children: [],
      requireToken: false,
    },
    {
      path: "/setpassword/:token",
      element: <Setpassword />,
      children: [],
      requireToken: false,
    },
    {
      path: "/invalidtoken",
      element: <TokenExpired />,
      children: [],
      requireToken: false,
    },
    {
      path: "/",
      element: <Dashboard />,
      children: [
        { path: "home", element: <One />, requireToken: true },
        { path: "customers", element: <Customerlist />, requireToken: true },
        {
          path: "salesprojects",
          element: <Salesprojects />,
          requireToken: true,
        },
        {
          path: "allocations",
          element: <PendingAllocations />,
          requireToken: true,
        },
        {
          path: "payments",
          element: <PaymentsDashboard />,
          requireToken: true,
        },
        { path: "reports",                              element: <Reports />,                  requireToken: true },
        { path: "reports/site_marking",                 element: <SiteMarkingReport />,        requireToken: true },
        { path: "reports/3d_discussion",                element: <ThreeDDiscussionReport />,   requireToken: true },
        { path: "reports/quotation_discussion",         element: <QuotationReport />,          requireToken: true },
        { path: "reports/2d_material",                  element: <TwoDMaterialReport />,       requireToken: true },
        { path: "reports/handover_pending",             element: <HandoverPendingReport />,    requireToken: true },
        { path: "reports/exec_cutlist_pending",         element: <CutlistPendingReport />,     requireToken: true },
        { path: "reports/exec_cutlist_done_no_plan",    element: <CutlistDoneReport />,        requireToken: true },
        { path: "reports/exec_factory_production",      element: <FactoryProdReport />,        requireToken: true },
        { path: "reports/exec_dispatch_pending",        element: <DispatchPendingReport />,    requireToken: true },
        { path: "reports/site_masking_pending",       element: <SiteMaskingPendingReport />, requireToken: true },
        { path: "reports/plan_vs_actual",             element: <PlanVsActualReport />,       requireToken: true },

        { path: "reports/exec_carcass",                 element: <CarcassReport />,            requireToken: true },
        { path: "reports/exec_accessories",             element: <AccessoriesReport />,        requireToken: true },
        { path: "reports/exec_final_fitting",           element: <FinalFittingReport />,       requireToken: true },
        { path: "reports/project_breakdown",            element: <ProjectBreakdownReport />,   requireToken: true },
        { path: "reports/timeline",                     element: <TimelineReport />,           requireToken: true },
        {
          path: "salesaddprojects",
          element: <Salesaddprojects />,
          requireToken: true,
        },
        {
          path: "salessignoffdoc",
          element: <Salessignoffdoc />,
          requireToken: true,
        },
        {
          path: "salessignoffdocview",
          element: <Salessignoffdocview />,
          requireToken: true,
        },
        {
          path: "salespreexecutionchecklist",
          element: <Salespreexecutionchecklist />,
          requireToken: true,
        },
        { path: "teammembers", element: <Teammembers />, requireToken: true },
        { path: "tasks", element: <Tasks />, requireToken: true },
        { path: "factory-production", element: <FactoryProduction />, requireToken: true },
        { path: "purchase", element: <PurchasePage />, requireToken: true },
        { path: "employees", element: <Employee />, requireToken: true },
        {
          path: "actualprocurementsales",
          element: <Actualprocurement />,
          requireToken: true,
        },
        {
          path: "civilintialprourement",
          element: <Civilintialprourement />,
          requireToken: true,
        },
        {
          path: "civilintialprocurelist",
          element: <Civilintialprocurelist />,
          requireToken: true,
        },
        {
          path: "civilactualprocurement",
          element: <Civilactualprocurement />,
          requireToken: true,
        },
        { path: "civilqueries", element: <Civilqueries />, requireToken: true },
        {
          path: "pettycashexpense",
          element: <PettyCashExpense />,
          requireToken: true,
        },
        {
          path: "subcontractorslist",
          element: <Subcontractorslist />,
          requireToken: true,
        },
        {
          path: "subcontractortype",
          element: <Subcontractortype />,
          requireToken: true,
        },
        {
          path: "subcontractorestimate",
          element: <SubcontractorEstimate />,
          requireToken: true,
        },
        {
          path: "purchaseintialprocurement",
          element: <Purchaseintialprocurement />,
          requireToken: true,
        },
        {
          path: "purhaselistitem",
          element: <Purchaselistitem />,
          requireToken: true,
        },
        { path: "vendorlist", element: <Vendorlist />, requireToken: true },
        { path: "vendortypes", element: <Vendortypes />, requireToken: true },
        {
          path: "vendorestimates",
          element: <VendorEstimates />,
          requireToken: true,
        },
        {
          path: "incomeandexpenses",
          element: <Incomeandexpenses />,
          requireToken: true,
        },
        { path: "pettycash", element: <Pettycash />, requireToken: true },
        { path: "customfooter", element: <Customfooter />, requireToken: true },
        { path: "cashbook", element: <CashBook />, requireToken: true },
        {
          path: "labourpaymentreport",
          element: <Labourpaymentreport />,
          requireToken: true,
        },

        //customer routers
        {
          path: "customerdashboard",
          element: <CustomerDashboard />,
          requireToken: true,
        },
        {
          path: "projecttracking",
          element: <ProjectTracking />,
          requireToken: true,
        },
        {
          path: "paymentdetails",
          element: <Paymentdetials />,
          requireToken: true,
        },
        {
          path: "actualprocurement",
          element: <Actualprocurement />,
          requireToken: true,
        },
        {
          path: "newrequest",
          element: <NewRequest />,
          requireToken: true,
        },
      ],
    },
    {
      path: "*",
      element: <Pagenotfound />,
      children: [],
      requireToken: false,
    },
  ];

  useEffect(() => {
    if (hasTokenValue && hasTokenValue !== "") {
      setHasToken(true);
    } else {
      setHasToken(false);
    }
  }, [hasTokenValue]);

  function handleChangeToken() {
    const token = localStorage.getItem("token");
    if (token !== null && token !== "") {
      setHasToken(true);
    } else {
      setHasToken(false);
    }
  }

  function handleRoute(route) {
    if (route.path === "/") {
      if (hasToken) {
        if (currentUserRole === "customer") {
          return <Navigate replace to={"/customerdashboard"}></Navigate>;
        }
        return <Navigate replace to={"/home"}></Navigate>;
      } else {
        return <Navigate replace to={"/login"}></Navigate>;
      }
    } else if (route.requireToken === false) {
      return route.element;
    } else if (route.requireToken === true) {
      if (hasToken) {
        return route.element;
      } else {
        return <Navigate replace to={"/login"}></Navigate>;
      }
    }
  }

  function getRoute(routesList) {
    return routesList.map((route, index) => {
      if (route["children"] && route["children"].length !== 0) {
        return (
          <Route path={route.path} element={route.element} key={route.path}>
            {getRoute(route["children"])}
          </Route>
        );
      }
      return (
        <Route
          path={route.path}
          element={handleRoute(route)}
          key={route.path}
        ></Route>
      );
    });
  }

  return (
    <Router>
      <Routes>{getRoute(routesList)}</Routes>
    </Router>
  );
};

export default Routers;
